import { Chip } from "@mui/material";
import { EComponentTypes } from "../../../Utils/Enums";
import { formatDate, setFontColorBasedOnBackground } from "../../../Utils/Utils";
import { Vocabulary } from "../../../Utils/Vocabulary";

// statusColor is the hidden column at index 1
const STATUS_COLOR_INDEX = 1;

export const clientsColumns = [
  {
    name: "statusName",
    label: Vocabulary.status,
    options: {
      customBodyRender: (value: string, tableMeta: any) => {
        const color = tableMeta.rowData[STATUS_COLOR_INDEX];
        return (
          <Chip
            label={value}
            style={{
              backgroundColor: color,
              color: color ? setFontColorBasedOnBackground(color) : undefined,
              fontWeight: "bold",
            }}
          />
        );
      },
      exportValue: (value: string) => value ?? "",
    },
  },
  {
    name: "statusColor",
    label: "",
    options: {
      display: false,
      filter: false,
      sort: false,
      viewColumns: false,
      download: false,
    },
  },
  {
    name: "clientName",
    label: Vocabulary.client,
  },
  {
    name: "clientPhone",
    label: Vocabulary.phone,
  },
  {
    name: "productName",
    label: Vocabulary.product,
  },
  {
    name: "workPointName",
    label: Vocabulary.workPoint,
  },
  {
    name: "instructorName",
    label: Vocabulary.instructor,
  },
  {
    name: "createdByName",
    label: Vocabulary.employee,
  },
  {
    name: "productPrice",
    label: Vocabulary.total,
    options: {
      customBodyRender: (value: number) => {
        return <div style={{ fontWeight: "bold" }}>{value}</div>;
      },
      exportValue: (value: number) => value ?? "",
    },
  },
  {
    name: "totalPayedAmount",
    label: Vocabulary.payed,
    options: {
      customBodyRender: (value: number) => {
        return (
          <div style={{ color: "green", fontWeight: "bold" }}>{value}</div>
        );
      },
      exportValue: (value: number) => value ?? "",
    },
  },
  {
    name: "totalLeftToPay",
    label: Vocabulary.restToPay,
    options: {
      customBodyRender: (value: number) => {
        return <div style={{ color: "red", fontWeight: "bold" }}>{value}</div>;
      },
      exportValue: (value: number) => value ?? "",
    },
  },
  {
    name: "totalPayedToInstructor",
    label: Vocabulary.payedToInstructor,
    options: {
      customBodyRender: (value: number) => {
        return (
          <div style={{ color: "#a7a707", fontWeight: "bold" }}>{value}</div>
        );
      },
      exportValue: (value: number) => value ?? "",
    },
  },
  {
    name: "createdAt",
    label: Vocabulary.createdAt,
    options: {
      customBodyRender: (value: Date) => {
        return formatDate(value);
      },
      exportValue: (value: Date) => (value ? formatDate(value) : ""),
    },
  },
];

/**
 * additional filters for the order status report
 */
export const clientsFilters = (orderStatuses: any) => [
  {
    property: "orderStatus",
    autocompleteFilterProperty: "_id",
    label: Vocabulary.orderStatus,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: orderStatuses[orderStatuses?.length - 1]._id,
    options: orderStatuses,
    otherOptions: { disableClearable: true },
  },
];
